import { useState } from "react";
import { useApp } from "../context/AppContext";

// NOTE: Wrap is defined OUTSIDE the page component (module scope) on purpose.
// Defining it inside used to break typing in the comment box — every keystroke
// re-created it as a "new" component, forcing React to unmount/remount the
// whole card (including the textarea) and losing focus after each character.
function Wrap({children}) {
  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#f0f3f9,#e6ebf4)",display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'DM Sans',sans-serif"}}>
      <style>{`@media (max-width:480px){ .rev-card{padding:28px 20px !important;} }`}</style>
      <div className="rev-card" style={{background:"#fff",borderRadius:18,padding:"40px 42px",maxWidth:480,width:"100%",boxShadow:"0 12px 50px rgba(10,22,40,0.12)",border:"1px solid #e4e9f0",textAlign:"center"}}>
        <img src="/logo-small.png" alt="AIHOVI" style={{height:56,objectFit:"contain",marginBottom:18}} onError={e=>e.target.style.display="none"}/>
        {children}
      </div>
    </div>
  );
}

export default function ApplicantReview({ params }) {
  const { getApp, submitReview } = useApp();
  const app = getApp(params?.app_id);

  const [rating, setRating]   = useState(0);
  const [hover,  setHover]    = useState(0);
  const [comment, setComment] = useState("");
  const [error,   setError]   = useState("");
  const [done,    setDone]    = useState(false);

  if (!app) return (
    <Wrap>
      <div style={{fontSize:42,marginBottom:10}}>🔗</div>
      <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:24,color:"#0d1f3c",marginBottom:8}}>Invalid or Expired Link</h2>
      <p style={{fontSize:13,color:"#6b7a90"}}>We couldn't find an application matching this review link on this device/browser. Please check the link, or ask the agent to resend it.</p>
    </Wrap>
  );

  if (app.review || done) return (
    <Wrap>
      <div style={{fontSize:42,marginBottom:10}}>💚</div>
      <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:24,color:"#0d1f3c",marginBottom:8}}>Thank You, {app.full_name.split(" ")[0]}!</h2>
      <p style={{fontSize:13,color:"#6b7a90",marginBottom:16}}>Your feedback has already been recorded. We really appreciate you taking the time.</p>
      {app.review && (
        <div style={{background:"#f6f8fc",borderRadius:12,padding:"16px 18px",textAlign:"left"}}>
          <div style={{fontSize:20,marginBottom:6}}>{"★".repeat(app.review.rating)}{"☆".repeat(5-app.review.rating)}</div>
          {app.review.comment && <p style={{fontSize:13,color:"#1a2540",fontStyle:"italic"}}>"{app.review.comment}"</p>}
        </div>
      )}
    </Wrap>
  );

  const handleSubmit = () => {
    if (rating === 0) { setError("Please select a star rating before submitting."); return; }
    submitReview(app.id, rating, comment.trim());
    setError("");
    setDone(true);
  };

  return (
    <Wrap>
      <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:24,fontWeight:700,color:"#0d1f3c",marginBottom:4}}>How was your experience?</h2>
      <p style={{fontSize:13,color:"#6b7a90",marginBottom:6}}>Hi {app.full_name.split(" ")[0]}, we'd love your feedback on your <strong>{app.service_type}</strong> application.</p>
      <p style={{fontSize:11,color:"#8a9bb5",marginBottom:22}}>Reference: {app.id}</p>

      <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:20}}>
        {[1,2,3,4,5].map(n => (
          <span key={n} onClick={()=>{setRating(n); setError("");}} onMouseEnter={()=>setHover(n)} onMouseLeave={()=>setHover(0)}
            style={{fontSize:38,cursor:"pointer",color:(hover||rating)>=n ? "#f5b301" : "#dde3ed",transition:"color 0.15s,transform 0.15s",transform:(hover===n)?"scale(1.15)":"scale(1)"}}>★</span>
        ))}
      </div>

      <textarea value={comment} onChange={e=>setComment(e.target.value)} rows={3} placeholder="Tell us more about your experience (optional)"
        style={{width:"100%",padding:"12px 14px",border:"1.5px solid #dde3ed",borderRadius:10,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:"#0d1f3c",outline:"none",resize:"vertical",boxSizing:"border-box",marginBottom:14}}/>

      {error && <div style={{color:"#dc2626",fontSize:12,marginBottom:12}}>⚠ {error}</div>}

      <button onClick={handleSubmit} style={{width:"100%",padding:"13px",background:"linear-gradient(135deg,#4a7fb5,#d4736a)",color:"#fff",border:"none",borderRadius:10,fontSize:14,fontWeight:600,cursor:"pointer"}}>Submit Review</button>
    </Wrap>
  );
}
